import axios from "axios";
import { createClient } from "../util/axios-helpers";
import { endpoint } from "../util/http-helpers";

export enum UnitDocumentType {
    Agreement = 0,
    Guide = 1
}

export interface UnitDocument {
    id: string;
    name: string;
    description: string;
    type: UnitDocumentType;
    blobUrl: string;
    fileName: string;
    fileSizeBytes: number;
    createdAt: string;
    updatedAt: string | null;
    deletedAt: string | null;
}

/**
 * Get documents for the current unit
 * @param type Optional filter by document type
 */
export const getDocuments = (type?: 'Agreement' | 'Guide') => {
    const client = createClient(axios);
    const url = type
        ? endpoint(`api/v1/documents?type=${type}`)
        : endpoint('api/v1/documents');
    return client.get<UnitDocument[]>(url);
};

/**
 * Get pending agreements that the guest needs to consent to
 */
export const getPendingAgreements = () => {
    const client = createClient(axios);
    return client.get<UnitDocument[]>(endpoint('api/v1/documents/pending-agreements'));
};

/**
 * Record consent for a document
 */
export const recordDocumentConsent = (documentId: string) => {
    const client = createClient(axios);
    return client.post(endpoint(`api/v1/documents/${documentId}/consent`));
};
